import p from "./pluralize.js";
import c from "./isEmpty.js";
var v = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/, d = function(s) {
  if (!s || s.length > 254)
    return !1;
  var i = v.test(s);
  if (!i)
    return !1;
  var a = s.split("@");
  if (a[0].length > 64)
    return !1;
  var l = a[1].split(".");
  return !l.some(function(n) {
    return n.length > 63;
  });
};
const x = {
  date: "Please enter a valid date",
  email: "Please enter a valid email address",
  max: "Cannot be more than {value}",
  maxEntries: "You cannot add more than {value} {entry|entries}",
  maxFileSize: "Your file exceeds {value}KB",
  maxLength: "You cannot enter more than {value} {character}",
  maxOptions: "You can only choose a maximum of {value} {option}",
  min: "Cannot be less than {value}",
  minEntries: "You must add at least {value} {entry|entries}",
  minLength: "Please enter at least {value} {character}",
  minOptions: "You must choose at least {value} {option}",
  pattern: "Invalid input",
  required: "This field is required",
  url: 'Please enter a valid URL, including "https://"'
}, A = (s, i) => {
  if (typeof i == "string") return i;
  let a = x[s], l = i;
  return i instanceof Array && ([l, a] = i), a.replace("{value}", l).replace(/{.*}/g, (n) => {
    const o = n.slice(1, -1), [e, r] = o.split("|");
    return p(l, e, r, !1);
  });
}, F = (s = {}) => {
  const i = ["minLength", "max", "min", "pattern"], a = {}, { deps: l, validate: n = {}, ...o } = s;
  return Object.keys(o).forEach((e) => {
    const r = A(e, o[e]), u = o[e] instanceof Array ? o[e][0] : o[e];
    i.includes(e) && (a[e] = {
      value: u,
      message: r
    }), e === "required" && (a.required = {
      value: !0,
      message: r
    }), e === "date" && (n.date = (t) => t ? /[0-9]{4}-[0-9]{2}/.test(t) || r : !0), e === "email" && (n.email = (t) => t ? t instanceof Array ? t.every(d) || r : d(t) || r : !0), (e === "minOptions" || e === "minEntries") && (n.minOptions = (t) => (t || []).length >= u || r), (e === "maxOptions" || e === "maxEntries") && (n.maxOptions = (t) => (t || []).length <= u || r), e === "url" && (n.url = (t) => t ? /^https:\/\/([^/\\: ]+\.)?[^/\\: ]+\.+/i.test(t) || r : !0), e === "maxFileSize" && (n.maxFileSize = (t) => {
      var m;
      const f = (m = t == null ? void 0 : t.split(",")) == null ? void 0 : m[1], h = u * 1024;
      if (!f) return !0;
      const g = (f.match(/=/g) || []).length;
      return f.length * 3 / 4 - g <= h || r;
    });
  }), c(l) || (a.deps = l), c(n) || (a.validate = n), a;
};
export {
  F as default,
  A as getValidationMessage
};
